module.exports = __webpack_public_path__ + "static/media/by.e25ab03c.svg";